import axios from '../utils/axios';

export default function resetPasswordLink(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/recover-password', data)
    )
}
